<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="missionId"
            :search-url="searchUrl"
            form-type="intable"
            custom-create-new
            custom-edit-item
            ref="tableData"
            :deleteMulti="false"
            orderBy="desc"
            :acceptView=false
            :accept-create="false"
            @getLogEA="getLogEA"
            @getLogMath="getLogMath"
        >
        </c-search-form>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/mission/MissionCreate";
import {message} from "@/shared/message";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Log bài học",
      searchUrl: null,
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'accountId',
          text: 'Account Id',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'phoneNumberAcc',
          text: 'Số điện thoại đăng ký',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'phoneNumberOrder',
          text: 'Số điện thoại mua hàng',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
/*        {
          value: 'isCheckAccount',
          text: 'Mô tả',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },*/
        {
          value: 'createDate',
          text: 'Ngày học',
          sortable: false,
          search: false,
          dateFormat: 'dd/MM/yyyy',
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'createDate',
          text: 'Giờ học',
          sortable: false,
          search: false,
          dateFormat: 'hh:mm:ss',
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'lessonName',
          text: 'Bài Học',
          sortable: false,
          search: false,
          width: "15%",
          headerStyle: "text-align:center",
        },
        {
          value: 'point',
          text: 'Kết quả học',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        }
      ]
    };
  },

  methods: {
    getLogEA(item) {
      this.$router.push({path: '/kidAccountClass/getLogEA/' + item.accountId, query: this.$route.query});
    },
    getLogMath(item) {
      this.$router.push({path: '/kidAccountClass/getLogMath/' + item.accountId, query: this.$route.query});
    },

  },
  created() {
    this.searchUrl ="/kidAccountClass/searchByPhone/" + this.$route.params.phone + "?sortField=status,classId&";
  }


};
</script>
